module.exports = __webpack_public_path__ + "static/media/Inventor Nesting.38784b27.png";